import React, { useState } from "react"
import { Modal } from 'react-bootstrap';
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import useCookie from "../../hooks/useCookie"
import videoPlayBtn from '../../images/Play-Button-x2.png';
import phonesmartlicence1 from "./../../images/phonesmart-licence-1.png"
import "./Video.scss";

const StaticVideo = ({ videoId, poster, engagement, transcript }) => {
	// console.log("videoId", videoId);
	const [userConsentCookie] = useCookie(process.env.GATSBY_USER_CONSENT_COOKIE);
	const videoConsentURL = (userConsentCookie === 'accept')?"https://www.youtube.com/embed/":"https://www.youtube-nocookie.com/embed/";
	// const videoPoster = getImage(data.image.localFile.image);
	const [show, setShow] = useState(false);
	const handleShow = () => { setShow(true); }
	const handleClose = () => { setShow(false); }

	if (videoId) {
		return (
			<section className="video-wrapper">
				<div className="poster-image static">
					<img src={poster} alt={"video poster"} />
					{(() => {
						// videoId =false;
						if (videoId) {
							return (
								<button className="playBtn" onClick={handleShow} data-analytics={`{"event":"videoEnagegment", "eventCategory":"${engagement} - Engagement", "eventAction":"CTA Click - Video action", "eventLabel":"Video Ad EE PhoneSmart"}`}> <img src={videoPlayBtn} alt="play video" className="play" /></button>
							)
						}
					})()}
				</div>
				<Modal show={show} onHide={handleClose} className="video-overlay">
					<Modal.Body>
						<button aria-label="Close" className="btn btn-secondary btn-close" onClick={handleClose}
							data-analytics={`{"event":"videoEnagegment", "eventCategory":"Video Ad EE PhoneSmart", "eventAction":"Finished Playing", "eventLabel":"Closed video overlay"}`}>X</button>
						<div className="youtube-video">
							{/* <div>
								<img src={phonesmartlicence1} alt="PhoneSmart Licence" className="" />
							</div> */}
							<div className="ratio ratio-16x9"> 
								<iframe src={`${videoConsentURL}${videoId}?autoplay=1&cc_load_policy=1`} className="embed-responsive-item" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>	
							</div>
						</div>
						<div className="transcript">
							<a href={transcript} className="link link-secondary" target="_blank" rel="noreferrer"
								data-analytics={`{"event":"videoEnagegment", "eventCategory":"Video Ad EE PhoneSmart", "eventAction":"Link Click", "eventLabel":"Video transcript"}`}>
								<span>&gt;&nbsp;</span> <b>Video transcript</b> 
								{/* {data.transcript_details} */}
							</a>
						</div>
					</Modal.Body>
				</Modal>
			</section>
		);
	} else {
		return <></>
	}
}

export default StaticVideo;
